export const namespaced = true

// states
export const state = {
  title: null
}

export const mutations = {
  SET_TITLE(state, title) {
    state.title = title
  }
}
